import { defineMessages } from '@dragonraider5/react-intl'
import { USER_NOT_FOUND } from 'inbonis-exception/lib'

export default defineMessages({
  title: {
    id: 'containers.PasswordRecovery.RecoverForm.title',
    description: 'Recover password form title',
    defaultMessage: '¿Has olvidado tu contraseña?'
  },
  info: {
    id: 'containers.PasswordRecovery.RecoverForm.info',
    description: 'Recover password form info',
    defaultMessage: 'Si has olvidado tu contraseña por favor intruduce tu email y en pocos minutos recibirás un email con instrucciones de cómo recuperarla.'
  },
  submitButton: {
    id: 'containers.PasswordRecovery.RecoverForm.buttons.submit',
    description: 'Submit Recover password form',
    defaultMessage: 'Recuperar contraseña'
  },
  loginLink: {
    id: 'containers.PasswordRecovery.RecoverForm.links.login',
    description: 'Recover password form login link',
    defaultMessage: 'Volver al inicio de sesión'
  },
  registerLink: {
    id: 'containers.PasswordRecovery.RecoverForm.links.register',
    description: 'Recover password form register link',
    defaultMessage: '¿No tienes usuario todavía?'
  },
  successMessageHTML: {
    id: 'containers.PasswordRecovery.RecoverForm.successMessage__html',
    description: 'Recover password success message',
    defaultMessage: '<p>Te hemos enviado un email con las instrucciones para restablecer tu contraseña</p>'
  },
  resetTitle: {
    id: 'containers.PasswordRecovery.ResetForm.title',
    description: 'Reset password form title',
    defaultMessage: 'Restablecer contraseña'
  },
  resetInfo: {
    id: 'containers.PasswordRecovery.ResetForm.info',
    description: 'Reset password form info',
    defaultMessage: 'Introduce tu nueva contraseña para crear una nueva.'
  },
  passwordField: {
    id: 'containers.PasswordRecovery.ResetForm.fields.password',
    description: 'Reset password form password field',
    defaultMessage: 'Nueva contraseña'
  },
  resetButton: {
    id: 'containers.PasswordRecovery.ResetForm.buttons.submit',
    description: 'Reset password form submit button',
    defaultMessage: 'Restablecer contraseña'
  },
  resetContinueButton: {
    id: 'containers.PasswordRecovery.ResetForm.buttons.continue',
    description: 'Reset password form continue button',
    defaultMessage: 'Continuar solicitud'
  },
  resetSuccessMessageHTML: {
    id: 'containers.PasswordRecovery.ResetForm.successMessage__html',
    description: 'Reset password success message',
    defaultMessage: '<p>Se ha restablecido tu contraseña correctamente.</p>'
  },
  [USER_NOT_FOUND]: {
    id: 'containers.PasswordRecovery.RecoveryForm.exceptions.USER_NOT_FOUND',
    description: 'Exception api message from USER_NOT_FOUND in password recovery',
    defaultMessage: 'Lo sentimos, no hemos encontrado un usuario con el e-mail introducido'
  }
})
